import {
    ERROR,
    LOADER,
    GET_LEAD_REPORTS,
    GET_APPLICATIONS_REPORT,
    GET_LIMIT_SANCTION_REPORT,
    GET_TRANCHE_REPORT,
    GET_SUPPLIER_REPORT,
    GET_DEMAND_REPORT,
    GET_REPAYMENT_REPORT,
    GET_ACTIVE_CUSTOMER_REPORT,
    GET_APPLICATION_ANALYTICS,
    GET_PAYMENT_TRANSACTION_REPORT,
    GET_REPORT_VIEWS,
    GET_QUERY_MANAGEMENT_REPORT,
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    leadReports: [],
    applicationsReport: [],
    limitSanctionReport: [],
    trancheReport: [],
    supplierReport: [],
    demandReport: [],
    repaymentReport: [],
    activeCustomerReport: [],
    applicationAnalytics: [],
    paymentTransactionReport: [],
    queryManagementReport: [],
    reportViews: [],
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_LEAD_REPORTS:
            return {
                ...state,
                loading: false,
                leadReports: { data: [...payload.leads], pagination: payload.pagination },
                error: null,
            };
        case GET_APPLICATIONS_REPORT:
            return {
                ...state,
                loading: false,
                applicationsReport: { data: [...payload.applications], pagination: payload.pagination },
                error: null,
            };
        case GET_LIMIT_SANCTION_REPORT:
            return {
                ...state,
                loading: false,
                limitSanctionReport: { data: [...payload.loans], pagination: payload.pagination },
                error: null,
            };
        case GET_TRANCHE_REPORT:
            return {
                ...state,
                loading: false,
                trancheReport: { data: [...payload.tranches], pagination: payload.pagination },
                error: null,
            };
        case GET_SUPPLIER_REPORT:
            return {
                ...state,
                loading: false,
                supplierReport: { data: [...payload.suppliers], pagination: payload.pagination },
                error: null,
            };
        case GET_DEMAND_REPORT:
            return {
                ...state,
                loading: false,
                demandReport: { data: [...payload.demand_reports], pagination: payload.pagination },
                error: null,
            };
        case GET_REPAYMENT_REPORT:
            return {
                ...state,
                loading: false,
                repaymentReport: { data: [...payload.rps], pagination: payload.pagination },
                error: null,
            };
        case GET_ACTIVE_CUSTOMER_REPORT:
            return {
                ...state,
                loading: false,
                activeCustomerReport: { data: [...payload.active_customers], pagination: payload.pagination },
                error: null,
            };
        case GET_APPLICATION_ANALYTICS:
            return {
                ...state,
                loading: false,
                applicationAnalytics: { data: [...payload.summary], pagination: payload.pagination },
                error: null,
            };
        case GET_PAYMENT_TRANSACTION_REPORT:
            return {
                ...state,
                loading: false,
                paymentTransactionReport: { data: [...payload.transactions], pagination: payload.pagination },
                error: null,
            };
        case GET_QUERY_MANAGEMENT_REPORT:
            return {
                ...state,
                loading: false,
                queryManagementReport: { data: [...payload.qms_data], pagination: payload.pagination },
                error: null,
            };
        case GET_REPORT_VIEWS:
            return {
                ...state,
                loading: false,
                reportViews: payload,
                error: null,
            };
        default:
            return state;
    }
};
